import React from "react";
import SearchBar from "./SearchBar";

/**
 * SearchOverlay
 * Floating search bar container that appears over control panels.
 */
const SearchOverlay = ({ search, setSearch, onClose }) => (
  <div className="animate-in slide-in-from-top-2 fade-in duration-300 flex justify-start w-full max-w-md">
    <SearchBar 
      value={search} 
      onChange={setSearch} 
      placeholder="Search..." 
      className="w-full"
    />
  </div>
);

export default SearchOverlay;
